import { type SvgComponentType } from "@newsela/angelou";

export enum InstructionSupportFiltersValuesEnum {
  decodable = "decodable",
  power_words = "power_words",
  formative = "formative",
  generation_genius_video = "GENERATION_GENIUS_VIDEO",
}

export interface IInstructionalFeatureOption {
  label: string;
  value: InstructionSupportFiltersValuesEnum;
  dataQaSelector: string;
  SvgComponent: SvgComponentType;
}
